import { render, staticRenderFns } from "./receiveModal.vue?vue&type=template&id=08ccd2ec&"
import script from "./receiveModal.vue?vue&type=script&lang=js&"
export * from "./receiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports